
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Prop, Vue} from "vue-property-decorator";
import UserChat from "@/ts/UserChat";
import {SizeEnum, UserType} from "@/ts/Enum";

@Component({
  computed: {
    nameSuffix() {
      if (this.user.type === UserType.teacher.toString()) {
        return '老师'
      } else if (this.user.type === UserType.student.toString()) {
        return '学生'
      } else {
        return '非登录人员'
      }
    }

  }
})
export default class UserChatItem extends Vue {
  @Prop() user: UserChat;

  size: SizeEnum = SizeEnum.large;

  focuscc() {
    console.log(this.user.id)
  }

  imgError(type, gender) {
    if (type == UserType.teacher) {
      return require(`@/assets/images/defaultHead.png`)
    } else if (type == UserType.student) {

      if (gender) {
        return require(`@/assets/images/na.png`)
      } else {
        return require(`@/assets/images/nv.png`)
      }
    } else {
      return require(`@/assets/images/defaultHead.png`)
    }
  }

}
